import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
// import { WebAuth } from 'auth0-js';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Store as NgrxStore } from '@ngrx/store';
import { UserState } from '../user-state';
import { UserSetCurrentUser, UserSetMtnAuthToken, UserSetRedirectUrl, UserSetUserPreferences } from '../user-actions';
import { Observable, Observer, Subscription } from 'rxjs';
import { MtnAccessToken } from './mtn-access-token';
import { TokenResponse } from './token-response';
import { map, tap } from 'rxjs/operators';
import { StorageService } from '../../core/util/storage.service';
import { UserProfileService } from '../../core/user-profile/user-profile.service';
import { UserPreferences } from '../../core/user-preferences/user-preferences';
import { WizardRunnerService } from '../../core/wizard/wizard-runner.service';
import { WelcomeWizard } from './welcome-wizard/welcome-wizard';
import { AssetReviewDialogComponent } from './asset-review-dialog/asset-review-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { HitTrackingService } from 'src/app/core/hit-tracking/hit-tracking.service';
import { USER_TRACKING_ACTION_DESCRIPTIONS, USER_TRACKING_ACTIONS, USER_TRACKING_SOURCES } from 'src/app/core/constants/user-tracking.constants';
import { LicenseType } from '../authorization/license-type.enum';


@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  // private auth0: WebAuth = new WebAuth({
  //   clientID: environment.AUTH_CONFIG.clientID,
  //   domain: environment.AUTH_CONFIG.domain,
  //   responseType: 'token id_token',
  //   audience: 'mtn-rest-api',
  //   redirectUri: environment.AUTH_CONFIG.callbackURL,
  //   scope: 'openid email profile'
  // });

  private subscriptions: Subscription[] = [];

  constructor(private http: HttpClient,
              private router: Router,
              private ngrxStore: NgrxStore<UserState>,
              private storageService: StorageService,
              private userProfileService: UserProfileService,
              private hitTracking : HitTrackingService,
              private wizardRunner: WizardRunnerService,
              private matDialog: MatDialog) {
  }

  clearAuthentication(): void {
    this.storageService.remove(StorageService.AUTH_CURRENT_USER).subscribe();
    this.storageService.remove(StorageService.AUTH_TOKEN).subscribe();
    this.ngrxStore.dispatch(UserSetMtnAuthToken({token: null}));
    this.ngrxStore.dispatch(UserSetCurrentUser({currentUser: null}));
  }

  public continueAuthentication(auth0Hash: string): Observable<boolean> {
    return new Observable<boolean>((observer: Observer<boolean>) => {
       this.authenticateWithMtn(auth0Hash)
            .subscribe((mtnAccessToken: MtnAccessToken) => {
              this.setAuthentication(mtnAccessToken);

              //const currentUser = mtnAccessToken.getCurrentUser();
              //const userEmail = currentUser?.email?.toLowerCase() || '';

              this.userProfileService.findOneUserPreferences(mtnAccessToken.getCurrentUser().uuid)
                .subscribe((userPreferences: UserPreferences) => {
                  this.ngrxStore.dispatch(UserSetUserPreferences({preferences: userPreferences}));

                  // Show asset review dialog first if not dismissed
                  const userUuid = mtnAccessToken.getCurrentUser().uuid;
                  const isDismissed = localStorage.getItem(`asset-review-dialog-dismissed-${userUuid}`) === 'true';
                  const userlicense= mtnAccessToken.getCurrentUser().licenseType;
                  console.log("user license : - ",userlicense);
                  if (!isDismissed && (userlicense === LicenseType.INTERNAL || userlicense === LicenseType.STANDARD)) {
                    const assetReviewDialogRef = this.matDialog.open(AssetReviewDialogComponent, {
                      width: '715px',
                      height: '254px',
                      disableClose: true,
                      hasBackdrop: true,
                      panelClass: 'asset-review-dialog-panel',
                      data: { userUuid }
                    });

                    assetReviewDialogRef.afterClosed().subscribe(() => {
                      if (!userPreferences.isWelcomeWizardComplete) {
                        const wizard = new WelcomeWizard();
                        wizard.model = {
                          userProfile: mtnAccessToken.getCurrentUser(),
                          userPreferences: userPreferences
                        };
                        this.wizardRunner.run(wizard);
                      }
                    });
                  } else if (!userPreferences.isWelcomeWizardComplete) {
                    const wizard = new WelcomeWizard();
                    wizard.model = {
                      userProfile: mtnAccessToken.getCurrentUser(),
                      userPreferences: userPreferences
                    };
                    this.wizardRunner.run(wizard);
                  }

                  observer.next(!!mtnAccessToken);
                });
            }, (err) => {
              if (err.status === 401 || err.status === 403) {
                this.router.navigate(['not-registered']);
              } else {
                this.router.navigate(['not-available']);
              }
            });
    });
  }

  public isAuthenticated(): Observable<boolean> {
    return this.storageService.get(StorageService.AUTH_TOKEN)
      .pipe(map((cachedToken: MtnAccessToken) => {
        return cachedToken ? new MtnAccessToken(cachedToken).isValid() : false;
      }));
  }

  public loadAuthenticationFromStorage(): void {
    this.storageService.get(StorageService.AUTH_TOKEN)
      .subscribe((cachedToken: MtnAccessToken) => {
        if (cachedToken) {
          cachedToken = new MtnAccessToken(cachedToken);
          if (cachedToken.isValid()) {
            this.ngrxStore.dispatch(UserSetMtnAuthToken({token: cachedToken}));
            this.ngrxStore.dispatch(UserSetCurrentUser({currentUser: cachedToken.getCurrentUser()}));
            this.userProfileService.findOneUserPreferences(cachedToken.getCurrentUser().uuid)
              .subscribe((userPreferences: UserPreferences) => {
                this.ngrxStore.dispatch(UserSetUserPreferences({preferences: userPreferences}));
              });
          } else {
            this.clearAuthentication();
          }
        }
      });
  }

  public logOut(): void {
    //const baseUrl = environment.AUTH_CONFIG.RS_W_BASE_URL;
    const req = {};
    this.hitTracking.hitTheUserTracking(
      USER_TRACKING_SOURCES.AUTHENTICATION_SERVICE,
      req,
      USER_TRACKING_ACTIONS.LOGOUT,
      USER_TRACKING_ACTION_DESCRIPTIONS[USER_TRACKING_ACTIONS.LOGOUT],
      false
    ).subscribe(() => {});
    this.clearAuthentication();
    this.auth0Logout();
  }

  public auth0Logout(): void {
  const returnTo = encodeURIComponent(environment.AUTH_CONFIG.logoutURL);
  console.log("🚀 ~ AuthenticationService ~ auth0Logout ~ returnTo:", returnTo)
  const baseUrl = environment.AUTH_CONFIG.RS_W_BASE_URL;
  window.location.href = `${baseUrl}/api/auth/logout?from=mtn`;
}

  public openAuth0AuthenticationDialog(): void {
     window.location.href = environment.AUTH_CONFIG.MTNRAServiceUrl;
  }

  public redirect(path: string): void {
    if (path && path !== '') {
      try {
        const parsedUri = decodeURI(path).split('?');
        const queryParams: any = {};
        if (parsedUri.length > 1) {
          const params = parsedUri[1].split('&');
          params.forEach(param => {
            const keyValue = param.split('=');
            queryParams[keyValue[0]] = keyValue[1];
          });
        }
        this.router.navigate([parsedUri[0]], {queryParams: queryParams})
          .then(() => this.storageService.remove(StorageService.AUTH_REDIRECT_URL).subscribe());
      } catch (err) {
        console.warn(err);
        this.router.navigate([''])
          .then(() => this.storageService.remove(StorageService.AUTH_REDIRECT_URL).subscribe());
      }
    } else {
      this.router.navigate([environment.defaultLandingPage])
        .then(() => this.storageService.remove(StorageService.AUTH_REDIRECT_URL).subscribe());
    }
  }

  public renewMtnAccessToken(token: string): Observable<boolean> {
    const url = `${environment.SERVICE_HOST}/api/insights/auth/renew`;
    const headers = this.buildAuthorizationHeader(token);

    return this.http.post<TokenResponse>(url, null, {headers: headers})
      .pipe(map((response: TokenResponse) => {
        if (response && response.token) {
          this.setAuthentication(new MtnAccessToken(response));
        }
        return response && !!response.token;
      }));
  }

  public setRedirectUrl(redirectUrl: string): void {
    if (redirectUrl && redirectUrl.indexOf('not-registered') === -1 && redirectUrl.indexOf('maintenance') !== -1) {
      this.storageService.set(StorageService.AUTH_REDIRECT_URL, redirectUrl).subscribe();
      this.ngrxStore.dispatch(UserSetRedirectUrl({url: redirectUrl}));
    }
  }

  private authenticateWithMtn(code: string): Observable<MtnAccessToken> {
  const url = `${environment.SERVICE_HOST}/api/insights/auth/rsw/authenticate?code=${code}&redirectUri=${environment.AUTH_CONFIG.callbackURL}`;//`${environment.SERVICE_HOST}/api/insights/auth/token`;
  const headers = new HttpHeaders({'Content-Type': 'application/json'});

   return this.http.post<any>(url,  { headers }).pipe(map((response: TokenResponse) => {
        if (response && response.token) {
          return new MtnAccessToken(response); // ✅ No warning
        }
        throw new Error('Unexpected response from authentication!');
      }),
      tap(() => {
        // Tracking AFTER token creation
        Promise.resolve().then(() => {
          const loginMetadata = this.hitTracking.getLoginMetadata();
          this.hitTracking.hitTheUserTracking(
            USER_TRACKING_SOURCES.RS_W,
            loginMetadata,
            USER_TRACKING_ACTIONS.LOGIN,
            USER_TRACKING_ACTION_DESCRIPTIONS[USER_TRACKING_ACTIONS.LOGIN],
            false
          ).subscribe(() => {});
        });
      })
    );
  }


  private buildAuthorizationHeader(auth0AccessToken: string): HttpHeaders {
    return new HttpHeaders({
      'Authorization': `Bearer ${auth0AccessToken}`
    });
  }

  private setAuthentication(mtnAccessToken: MtnAccessToken): void {
    console.log("🚀 ~ AuthenticationService ~ setAuthentication ~ mtnAccessToken:", mtnAccessToken)
    this.storageService.set(StorageService.AUTH_TOKEN, mtnAccessToken).subscribe();
    this.ngrxStore.dispatch(UserSetMtnAuthToken({token: mtnAccessToken}));
    this.ngrxStore.dispatch(UserSetCurrentUser({currentUser: mtnAccessToken.getCurrentUser()}));
  }

  public isAuthenticatedStandardLicense(): Observable<boolean> {
    return this.storageService.get(StorageService.AUTH_TOKEN)
      .pipe(map((cachedToken: MtnAccessToken) => {
        if (!cachedToken) {
          return false;
        }
        const token = new MtnAccessToken(cachedToken);
        return token.isValid() && token.getCurrentUser()?.licenseType === LicenseType.STANDARD;
      }));
  }

  public addSubscription(subscription: Subscription): Subscription {
    this.subscriptions.push(subscription);
    return subscription;
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub?.unsubscribe());
    this.subscriptions = [];
  }

}
